import { css } from "styled-components";
import { createStyleComponent } from "@hzero-front-ui/core/lib/utils";
var dropdownStyle = function dropdownStyle() {
  return css([".ant-dropdown{.ant-dropdown-menu-item:hover,.ant-dropdown-menu-submenu-title:hover{background-color:#e6f0ff;}}"]);
};
export default createStyleComponent("dropdown", dropdownStyle);